import React from 'react';

function ProductStar({id, index, fill}) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24">
            <defs>
                <linearGradient id={`product-star-gradient-${id}-${index}`} x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset={`${fill}%`} stopColor="#FACC15"/>
                    <stop offset={`${fill}%`} stopColor="#CCCCCC"/>
                </linearGradient>
            </defs>
            <path d="M12 .587l3.668 7.431L24 9.753l-6 5.848L19.335 24 12 19.897 4.665 24 6 15.601 0 9.753l8.332-1.735z" fill={`url(#product-star-gradient-${id}-${index})`}/>
        </svg>
    );
}

export default ProductStar;